<template>
  <div>
    <div class="knowDatil">
      <div class="top-list">
        <!-- 近五年高考考频 0 年级得分率 53.69% 年级考察题数 5 -->
        <p>{{ searchData.knowledgeName }}</p>
        <div>
          近五年考频：<span
            ><template v-if="questionData.knowledgeFreq">{{
              questionData.knowledgeFreq
            }}</template
            ><template v-else>无</template></span
          >
        </div>
        <div>
          <template v-if="$route.query.urlType == 'GradeLearning'"
            >年级得分率：</template
          >
          <template v-if="$route.query.urlType == 'ClassLearning'"
            >班级得分率：</template
          >
          <template v-if="$route.query.urlType == 'StudentLearning'"
            >个人得分率：</template
          >
          <span>{{ questionData.scoreRateAvg | setNumber }}</span>
        </div>
        <div>
          <template v-if="$route.query.urlType == 'GradeLearning'"
            >年级考察题数：</template
          >
          <template v-if="$route.query.urlType == 'ClassLearning'"
            >班级考察题数：</template
          >
          <template v-if="$route.query.urlType == 'StudentLearning'"
            >个人考察题数：</template
          >
          <span>{{ questionData.questionCount }}</span>
        </div>
      </div>
      <div v-if="examDateListY.length > 0" class="echarts-box">
        <div id="myChart" :style="{ width: '100%', height: '200px' }"></div>
      </div>
      <template v-if="$route.query.knowType == 'GradeLearning'">
        <p class="title">掌握情况</p>
        <div class="sort-box">
          <div
            v-for="v in sortList"
            :key="v.val"
            class="sort-list"
            :class="{ on: v.click }"
            @click="sortClick(v)"
          >
            {{ v.name }}
          </div>
        </div>
        <div class="class-list">
          <template
            v-if="
              sortList.filter((item) => item.click).length > 0 &&
              sortList.filter((item) => item.click)[0].val == 2
            "
          >
            <span v-for="(v, i) in masterData.masteredList" :key="i">
              {{ v.name }}班 {{ v.scoreRateAvg | setNumber }}</span
            >
          </template>
          <template
            v-if="
              sortList.filter((item) => item.click).length > 0 &&
              sortList.filter((item) => item.click)[0].val == 3
            "
          >
            <span v-for="(v, i) in masterData.unmasterList" :key="i">
              {{ v.name
              }}<template v-if="$route.query.knowType != 'StudentLearning'"
                >班</template
              >
              {{ v.scoreRateAvg | setNumber }}</span
            >
          </template>
        </div>
      </template>
      <!-- <p class="title">错题</p> -->
    </div>

    <!-- <wrongQuestion :search-data="searchData"></wrongQuestion> -->
  </div>
</template>

<script>
import { masterinfo, paperlistinfo, questionInfo } from "@/api/interface";
// import wrongQuestion from "@/components/learning/wrongQuestion";
export default {
  name: "KnowDatil",
  components: {
    // wrongQuestion
  },
  props: { searchData: Object },
  data() {
    return {
      paperData: {},
      questionData: {},
      masterData: {},
      examDateListY: [],
      examDateListX: [],
      scoreRateAvg: "",
      sortList: [
        // { name: "知识点", val: 1, click: false },
        { name: "已掌握", val: 2, click: false },
        { name: "未掌握", val: 3, click: false },
      ],
    };
  },
  created() {
    this.sortList[0].click = true;
    this.getInfo();
    if (this.$route.query.classNum) {
      this.sortList[0].name = "学生已掌握";
      this.sortList[1].name = "学生未掌握";
    } else {
      this.sortList[0].name = "班级已掌握";
      this.sortList[1].name = "班级未掌握";
    }
  },
  methods: {
    drawLine() {
      // console.log(this.$echarts);
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      // 绘制图表
      myChart.setOption({
        title: {
          // subtext: "得分率" + this.scoreRateAvg,
          // color: "#000000",
          // left: "20px",
          top: "20px",
          textStyle: {
            color: "#333333",
            fontWeight: "bold",
            fontSize: 14,
          },
        },
        xAxis: {
          type: "category",
          data: this.examDateListY,
        },
        yAxis: {
          type: "value",
          axisLabel: {
            formatter: "{value} %",
          },
          //  min:95,
          max: 100,
        },
        grid: {
          // top: '4%',
          left: "0%",
          right: "0%",
          bottom: "0%",
          containLabel: true,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        series: [
          {
            data: this.examDateListX,
            type: "line",
            color: ["#7b9cc7"],
            // itemStyle: { normal: { label: { show: true } } }
          },
        ],
      });
    },
    sortClick(v) {
      this.sortList.forEach((i) => {
        i.click = false;
      });
      v.click = true;
    },
    getInfo() {
      let data = JSON.parse(JSON.stringify(this.searchData));
      delete data.knowledgeName;
      // delete data.subjectId;
      // delete data.timeRange;
      // delete data.gradeId;
      delete data.isWeb;
      delete data.knowType;
      paperlistinfo(data).then((res) => {
        this.paperData = res.data;
        this.examDateListY = [];
        this.examDateListX = [];
        this.scoreRateAvg =
          (this.paperData.scoreRateAvg * 100).toFixed(2) + " %";
        this.paperData.examPaperList.forEach((index) => {
          this.examDateListY.push(index.examDate);
          let num = (index.scoreRateAvg * 100).toFixed(2);
          this.examDateListX.push(num);
        });
        if (this.examDateListY.length == 0) {
          return;
        }
        this.$nextTick(() => {
          this.drawLine();
        });
      });
      questionInfo(data).then((res) => {
        this.questionData = res.data;
      });
      masterinfo(data).then((res) => {
        this.masterData = res.data;
      });
    },
  },
};
</script>
<style scoped lang="scss">
.knowDatil {
  padding: 30px 12px 0;
  .class-list {
    display: flex;
    align-items: center;
    margin-top: 8px;
    flex-wrap: wrap;
    span {
      color: rgba(0, 0, 0, 0.5);
      margin-right: 20px;
      margin-bottom: 8px;
    }
  }
  .title {
    color: #7b9cc7;
    margin-top: 5px;
  }
  .sort-box {
    display: flex;
    // justify-content: space-between;
    .sort-list {
      padding: 15px 0 8px;
      margin-right: 12px;
      position: relative;
      color: rgba(0, 0, 0, 0.5);
      // &:first-child {
      //   padding-left: 0;
      // }
    }
    .on {
      color: rgba(0, 0, 0, 0.85);
      &::after {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        -webkit-transform: translateX(-50%); /* Safari 和 Chrome */
        -o-transform: translateX(-50%); /* Opera */
        width: 40px;
        height: 4px;
        border-radius: 2px;
        background-color: #7b9cc7;
        content: "";
      }
    }
  }
  .top-list {
    background: rgba(0, 0, 0, 0.04);
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    padding: 10px;
    p {
      width: 100%;
      margin-bottom: 10px;
      color: #7b9cc7;
    }
    div {
      color: rgba(0, 0, 0, 0.5);
    }
    span {
      color: rgba(0, 0, 0, 0.85);
    }
  }
}
</style>
